import { listingReducer } from "../reducers/utils/listingReducer";
import { getUsers } from "../../services/Users";

const { reducer, actions, types } = listingReducer({
  name: `users`,
  getApi: getUsers,
});
const users = reducer;
export { users, actions, types };
